import React from "react";
import styled from "styled-components";
import EmailCard from "./EmailCard";
import { useState, useEffect } from "react";
import { data } from "jquery";
import { ASSET_TYPE } from "../../../constants/index";
import { getQueryAssetId } from "modules/EmailBrowser/utils";

interface EmailCardProps {
  data: any;
  campaignId: number;
  assetType?: string;
}
export default function EmailCardWrapper(props: EmailCardProps) {
  const [myDate, setMyDate] = useState("");
  const [myMonth, setMyMonth] = useState("");
  // const [subject, setSubject] = useState(props?.data?.subject);
  // const [name, setName] = useState(props?.data?.name);
  const { name, subject } = props.data;

  const splitDayMonth = () => {
    const myArr = props.data.last_update.split(" ");
    setMyDate(myArr[0].toString());
    setMyMonth(myArr[1].toString());
  };

  useEffect(() => {
    if (props?.data?.last_update) {
      splitDayMonth();
    }
  }, [props?.data?.last_update]);

  return (
    <>
      <EmailCard
        id={props.data.version_id}
        date={myDate}
        month={myMonth}
        calendar={props.data.last_update === null || myDate === "" ? false : true}
        wide={true}
        img={props.data.thumbnail}
        draftName={name}
        draftTitle={
          subject
            ? subject
            : props.assetType === ASSET_TYPE.CUSTOM
            ? "Ad hoc Draft subject line here, and can be up to two lines long"
            : "Email Draft subject line here, and can be up to two lines long"
        }
        curatedArticlesCount={props.data.curated_articles_count}
        assetType={props.assetType}
        campaignId={props.campaignId}
        assetId={getQueryAssetId()}
      />
    </>
  );
}
